// I paragrafi registrati con §: quelli che md2pdf sa citare.
//
// L'elenco si legge dal SORGENTE e non da un indice a parte, perché un indice
// a parte diverge dal documento nel momento esatto in cui serve.

export interface Paragrafo
{
    id: string;
    titolo: string;
    livello: number;
    riga: number;
    /** Offset del carattere iniziale della riga: l'editor ci salta sopra. */
    da: number;
}

const INTESTAZIONE = /^(#{1,6})\s+(.*?)\s*§([A-Za-z][A-Za-z0-9_.-]*)\s*$/;


export function leggiParagrafi(testo: string): Paragrafo[]
{
    const trovati: Paragrafo[] = [];
    let offset = 0;

    testo.split("\n").forEach((riga, i) =>
    {
        const m = INTESTAZIONE.exec(riga);

        if (m !== null && m[1] !== undefined && m[2] !== undefined && m[3] !== undefined)
        {
            trovati.push({
                id: m[3],
                titolo: m[2],
                livello: m[1].length,
                riga: i + 1,
                da: offset,
            });
        }

        offset += riga.length + 1;
    });

    return trovati;
}
